import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import {
  fetchTokens, showSaveToken, updateTokensFilter,
} from '../actions';
import myTokens, { canReadToken } from '../helper';

const TokensPanelContainer = ({
  readErrors,
  canRead,
  className,
  children,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-tokens-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  auth: { role },
  tokens: { tokens },
}, { category }) => {
  const item = tokens[category];
  return {
    canRead: canReadToken(category, role),
    canCreate: myTokens(category) && role.permissions.users.token_create,
    allowRoleLink: role.permissions.roles.read,
    allowUserLink: role.permissions.users.read,
    tokens: item.results,
    filterTerm: item.filter,
    readStatus: item.readStatus,
    readErrors: item.readErrors,
    total: item.count,
    currentPage: item.currentPage,
    pageSize: item.pageSize,
    pageCount: item.totalPages,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchTokens,
  updateFilterTerm: updateTokensFilter,
  newToken: () => showSaveToken(null, null),
};

export default TokensPanelContainer;
